export enum PromoEventValues {
	CheckoutReason = 'promo_event_button',
}
